import React, { useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
type ContentImage = {
  src: string;
  alt: string;
};
type ContentCarouselProps = {
  images: ContentImage[];
};
export function ContentCarousel({
  images
}: ContentCarouselProps) {
  const trackRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const goToSlide = (index: number) => {
    const nextIndex = Math.max(0, Math.min(index, images.length - 1));
    const slide = trackRef.current?.children[nextIndex] as HTMLElement | undefined;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    slide?.scrollIntoView({
      behavior: reducedMotion ? 'auto' : 'smooth',
      block: 'nearest',
      inline: 'start'
    });
    setActiveIndex(nextIndex);
  };
  const updateActiveSlide = () => {
    const track = trackRef.current;
    if (!track) return;
    const trackCenter = track.scrollLeft + track.clientWidth / 2;
    const nearestIndex = Array.from(track.children).reduce((closestIndex, slide, index) => {
      const closest = track.children[closestIndex] as HTMLElement;
      const current = slide as HTMLElement;
      const closestDistance = Math.abs(closest.offsetLeft + closest.offsetWidth / 2 - trackCenter);
      const currentDistance = Math.abs(current.offsetLeft + current.offsetWidth / 2 - trackCenter);
      return currentDistance < closestDistance ? index : closestIndex;
    }, 0);
    setActiveIndex(nearestIndex);
  };
  return <section className="content-carousel" aria-roledescription="carrusel" aria-label="Vista previa del contenido incluido" data-id="element-28" data-mp="rz24kkm9wpom">
      <div className="content-carousel-track" ref={trackRef} onScroll={updateActiveSlide} tabIndex={0} aria-label="Desliza para ver las herramientas incluidas" data-id="element-29" data-mp="n70w79s87j3v">
        {images.map((image, index) => <figure className="content-slide" key={image.src} aria-label={`Vista previa ${index + 1} de ${images.length}`} data-id="element-30" data-mp="k8bs1cldg458" data-mpi={index}>
            <img src={image.src} alt={image.alt} data-id="element-31" data-mp="o7kkme4odvz7" />
            <figcaption data-id="element-32" data-mp="t0405gmxb16n">{index + 1} de {images.length}</figcaption>
          </figure>)}
      </div>

      <div className="content-carousel-controls" data-id="element-33" data-mp="xyfartl1lfpx">
        <button type="button" className="carousel-control" onClick={() => goToSlide(activeIndex - 1)} disabled={activeIndex === 0} aria-label="Ver contenido anterior" data-id="element-34" data-mp="y1b6rcdbxubq">
          <ChevronLeftIcon size={19} aria-hidden="true" data-id="element-35" data-mp="a9ct4lqermvf" />
        </button>
        <p className="content-carousel-status" aria-live="polite" data-id="element-36" data-mp="f8z7iyhz395t">
          {activeIndex + 1} de {images.length}
        </p>
        <button type="button" className="carousel-control" onClick={() => goToSlide(activeIndex + 1)} disabled={activeIndex === images.length - 1} aria-label="Ver siguiente contenido" data-id="element-37" data-mp="1lpkpg5f8y1yn">
          <ChevronRightIcon size={19} aria-hidden="true" data-id="element-38" data-mp="3b5evtnff3f4f" />
        </button>
      </div>
      <p className="content-swipe-hint" data-id="element-39" data-mp="367lrkzxocv6s">Desliza para explorar el contenido</p>
    </section>;
}